var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6","offset-md":"3"}},[_c('v-card',{staticClass:"mx-auto center",attrs:{"tile":""}},[_c('BreathList')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }